import * as Icons from './theme/icons';

const getIconsObject = (list: any, prefix: string | null = null): { [key: string]: string } => {
  let toReturn: { [key: string]: string } = {};

  for (const name in list) {
    if (typeof list[name] === 'object' && list[name] !== null && !Array.isArray(list[name])) {
      toReturn = { ...toReturn, ...getIconsObject(list[name], prefix ? `${prefix}.${name}` : name) };
    } else if (typeof list[name] === 'string') {
      toReturn[prefix ? `${prefix}.${name}` : name] = list[name];
    }
  }

  return toReturn;
};

export const IconsFlatObject = () => getIconsObject(Icons);
export const IconsList = () => Object.keys(getIconsObject(Icons));
export const ImagesList = () => ['general.logoWithText', 'general.customFile', 'analytics.emptyEye', 'analytics.emptyCalendar', 'upselling.starInCircle'];
